var map = {
	"./background-branch-detail.svg": "./src/assets/backgrounds/background-branch-detail.svg",
	"./background-document-detail.svg": "./src/assets/backgrounds/background-document-detail.svg",
	"./background-fl-detail.svg": "./src/assets/backgrounds/background-fl-detail.svg",
	"./background-pos-detail.svg": "./src/assets/backgrounds/background-pos-detail.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/backgrounds sync recursive ^\\.\\/background\\-.*\\-detail\\.svg$";